import React, { useState } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';

import { useDispatch } from 'react-redux';
import { TP_COLORS } from '../../../../constants';
import { DashedDivider, primaryButtonProps, titleStackProps } from '..';

import { IUserAchievement } from '../../../../store/UserSlice';
import { deleteUserAchievement } from '../../../../store/UserSlice/UserApi';

import DeleteConfirmationModal from './modals/DeleteConfirmationModal';
import AddAchievementModal from './modals/AddAchievementModal';
import AchievementListItem from './components/AchievementListItem';

interface AchievementSectionProps {
  achievementList: IUserAchievement[];
}

const AchievementSection: React.FC<AchievementSectionProps> = ({
  achievementList,
}) => {
  const dispatch = useDispatch();

  // State
  const [isAddAchievementModalOpen, setAddAchievementModalOpen] = useState(
    false
  );
  const [isDeleteConfirmModalOpen, setDeleteConfirmModalOpen] = useState(false);
  const [selectedAchievementItem, setSelectedAchievementItem] = useState<
    IUserAchievement | undefined
  >(undefined);

  const handleAchievementActions = (
    type: 'edit' | 'delete',
    achievementData: IUserAchievement
  ) => {
    if (type === 'edit') {
      setAddAchievementModalOpen(true);
    } else {
      setDeleteConfirmModalOpen(true);
    }
    setSelectedAchievementItem(achievementData);
  };

  const handleAchievementAdd = () => {
    setAddAchievementModalOpen(true);
    setSelectedAchievementItem(undefined);
  };

  const handleAchievementDelete = () => {
    if (selectedAchievementItem && selectedAchievementItem._id) {
      dispatch(deleteUserAchievement(selectedAchievementItem._id));
    }
    setDeleteConfirmModalOpen(false);
  };

  return (
    <Box>
      <Stack {...titleStackProps}>
        <Typography variant="h6" fontSize="18px">
          Achievement
        </Typography>

        <Button {...primaryButtonProps} onClick={handleAchievementAdd}>
          + Add New
        </Button>
      </Stack>

      <Stack>
        {achievementList.length ? (
          achievementList.map((achievementItem, index) => (
            <AchievementListItem
              key={index}
              achievementData={achievementItem}
              handleActions={handleAchievementActions}
            />
          ))
        ) : (
          <Typography
            variant="subtitle2"
            color={TP_COLORS.gray.darken}
            textAlign="center"
          >
            No achievements are available, Please add to display.
          </Typography>
        )}
      </Stack>

      <DashedDivider />

      {/* Modals */}
      {isAddAchievementModalOpen && (
        <AddAchievementModal
          open={isAddAchievementModalOpen}
          selectedAchievementItem={selectedAchievementItem}
          onClose={() => setAddAchievementModalOpen(false)}
        />
      )}
      {isDeleteConfirmModalOpen && (
        <DeleteConfirmationModal
          title="achievement"
          open={isDeleteConfirmModalOpen}
          onSubmit={handleAchievementDelete}
          onClose={() => setDeleteConfirmModalOpen(false)}
        />
      )}
    </Box>
  );
};

export default AchievementSection;
